// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".thsj .el-col-3 div[data-v-81c80f8a]{font-size:18px;margin-top:10px}.text-title[data-v-81c80f8a]{color:rgba(0,0,0,.5)}.title[data-v-81c80f8a]{border-right:1px solid rgba(0,0,0,.1);padding:10px}", ""]);
// Exports
module.exports = exports;
